@if (passport) {
  @if (shouldShowEmptyState()) {
    <ix-layout-grid>
      <ix-row>
        <ix-col class="d-flex justify-content-center" size="12">
          <ix-empty-state
            class="mt-5"
            header="{{ 'battery_pass.viewer.empty_passport_view.header' | translate }}"
            icon="error"
            subHeader="{{ 'battery_pass.viewer.empty_passport_view.sub_header' | translate }}"
          ></ix-empty-state>
        </ix-col>
      </ix-row>
    </ix-layout-grid>
  } @else {
  <div>
    <ix-row>
      <ix-col class="show-on-small-screen">
        <div [style.background-image]="'url(' + passportImage + ')'"
          class="small-fav-image w-100 mb-3 position-relative overflow-hidden">
          <div class="fade-out-bar position-absolute pointer-events-none"></div>
        </div>
        <ix-typography class="mb-2" format="display-sm">
          {{ 'battery_pass.viewer.overview' | translate }}
        </ix-typography>
        <ix-key-value-list
          [style.background-image]="'url(' + passportImage + ')'">
          @for (card of detailCardContent; track card) {
            <ix-key-value
              [label]="card.label | translate">
              @if (card.value; as value) {
                <ix-typography slot="custom-value">{{ value }}</ix-typography>
              } @else {
                <ix-pill slot="custom-value"
                  variant="neutral">{{ 'battery_pass.viewer.no_value' | translate }}
                </ix-pill>
              }
            </ix-key-value>
          }
        </ix-key-value-list>
      </ix-col>
      <ix-col class="detail-cards-container" size="8" sizeSm="12">
        @for (card of detailCardContent; track card; let cardIndex = $index) {
          <ix-card
            class="detail-card">
            <ix-card-content class="p-2">
              <ix-key-value
                [icon]="card.icon"
                [label]="card.label | translate"
                class="border-bottom-0 w-100"/>
                @if (card.value; as value) {
                  <ix-typography
                    class="text-nowrap ellipsis w-100"
                    id="detailCardValue-{{cardIndex}}">
                    {{ value }}
                  </ix-typography>
                  <ix-tooltip for="#detailCardValue-{{cardIndex}}">
                    {{ card.label | translate }}: {{ value }}
                  </ix-tooltip>
                } @else {
                  <ix-pill
                    variant="neutral">{{ 'battery_pass.viewer.no_value' | translate }}
                  </ix-pill>
                }
              </ix-card-content>
            </ix-card>
          }
        </ix-col>
        <ix-col size="4" sizeSm="12">
          <ix-card class="w-100 h-100 show-not-on-small-screen">
            <ix-card-content
              [style.background-image]="'url(' + passportImage + ')'"
              class="d-flex flex-column fav-image">
            </ix-card-content>
          </ix-card>
        </ix-col>
      </ix-row>
      @if (uiSchema?.['ui:isDummyPassport']) {
        <ix-row class="mb-3">
          <ix-message-bar [persistent]="true"
            class="w-100"
            type="warning">
            {{ 'battery_pass.viewer.dummy_passport_warning' | translate }}
          </ix-message-bar>
        </ix-row>
      }
      <ix-row class="sticky-top tabs-background z-2">
        @if (showTabs) {
          <ix-col size="12">
            @if (!WindowSizeService.windowSizeSmall()) {
              <ix-tabs
                [selected]="selectedTabIndex">
                @for (category of categories; track category; let categoryIndex = $index) {
                  <ix-tab-item
                    (click)="changeTab(categoryIndex)"
                    onkeypress=""
                    >
                    <span class="category-tab">
                      @if (this.batteryPassCategoryIcons[category.name]) {
                        <ix-icon
                          [name]="this.batteryPassCategoryIcons[category.name]"/>
                      }
                      <ix-typography id="passViewerTabs.{{ category.name }}">
                        {{ category.translation.short ?? category.translation.label | translate }}
                      </ix-typography>
                    </span>
                  </ix-tab-item>
                }
              </ix-tabs>
            }
            <div class="show-on-small-screen">
              <ix-typography class="mb-3" format="display-sm">
                {{ 'battery_pass.viewer.categories' | translate }}
              </ix-typography>
              @if (categories) {
                <ix-dropdown-button
          [label]="categories[selectedTabIndex].translation.short ??
                   categories[selectedTabIndex].translation.label  | translate"
                  class="w-100"
                  variant="secondary">
                  @for (category of categories; track category; let categoryIndex = $index) {
                    <ix-dropdown-item
                      (click)="changeTab(categoryIndex)"
                      [label]="category.translation.short ?? category.translation.label | translate"
                      onkeypress="">
                    </ix-dropdown-item>
                  }
                </ix-dropdown-button>
              }
            </div>
          </ix-col>
        }
      </ix-row>
      <ix-row>
        @if (categories) {
          <ix-col class="gap-1" size="12">
            @for (subCategory of categories[selectedTabIndex].attributes; track subCategory; let subCatIndex = $index) {
              <ix-blind
                [collapsed]="false"
                [label]="subCategory.translation.label | translate"
                class="category-blind">
                <p id="overflowIndicator-{{subCatIndex}}" class="overflow-indicator">
                  ({{subCategory.translation.label | translate}})
                </p>
                @if (isOverflown('overflowIndicator-' + subCatIndex)) {
                  <div class="show-below-1100 subcategory-heading">
                    <ix-typography format="label-lg" textColor="weak">
                      {{subCategory.translation.label | translate}}
                    </ix-typography>
                  </div>
                }
                <ix-key-value-list>
                  @for (attribute of subCategory.attributes; track attribute) {
                    <app-viewer-field
                      [attribute]="attribute" [passport]="passport" [schemaId]="schema.id"/>
                  }
                </ix-key-value-list>
              </ix-blind>
            }
          </ix-col>
        }
      </ix-row>
    </div>
  }
  }
